module.exports = ".colorSquareStyle{flex-grow:1;align-items:center;justify-content:center}.colorSquareStyle>div{text-align:center;font-size:medium}\n"